import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: 'sAltselect',
})
export class AltselectDirective {
    public constructor(public el?: ElementRef) {}
}
